// Single source of truth for "what makes a password acceptable" across the auth flows —
// sign-up step 2 and the reset-password step both validate against and render these, so a
// password accepted in one place is accepted in the other. <PasswordStrength> shows them.

export type PasswordCheck = {
  key: string;
  met: boolean;
  /** English fallback for the `authPage.signup.password.req.<key>` translation. */
  defaultValue: string;
};

export const buildPasswordChecks = (pwd: string): PasswordCheck[] => [
  { key: 'len', met: pwd.length >= 8, defaultValue: 'At least 8 characters' },
  {
    key: 'case',
    met: /[a-z]/.test(pwd) && /[A-Z]/.test(pwd),
    defaultValue: 'Uppercase and lowercase letter',
  },
  { key: 'number', met: /\d/.test(pwd), defaultValue: 'At least 1 number' },
  { key: 'special', met: /[^A-Za-z0-9]/.test(pwd), defaultValue: 'At least 1 special character' },
];

export const isStrongPassword = (pwd: string) => buildPasswordChecks(pwd).every((c) => c.met);

export const WEAK_PASSWORD_MESSAGE = 'Please choose a password that meets every requirement.';
